import styled from "styled-components";

type Props = {
  isDisabled: boolean;
};

export const Container = styled.div`
  margin-top: 36px;
`;

export const CardContainer = styled.div<Props>`
  margin: 20px;
  background-color: ${(props) => (props.isDisabled ? "#e4e4e4" : "#fff")};
`;

export const CardTitle = styled.div<Props>`
  background-color: ${(props) => (props.isDisabled ? "#707070" : "#fdd440")};
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 9px;
  padding-bottom: 9px;
`;

export const CardTitleText = styled.span<Props>`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => (props.isDisabled ? "#F6F6F6" : "#1070b6")};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 9px;
  padding-bottom: 9px;
`;

export const SkipThisChapterButton = styled.button<Props>`
  background-color: ${(props) => (props.isDisabled ? "#b4b4b4" : "#d3e8ff")};
  color: ${(props) => (props.isDisabled ? "#707070" : "#1070b6")};
  display: block;
  width: 100%;
  border: none;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.35px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: ${(props) => (props.isDisabled ? "#9e9e9e" : "#d3e8ff")};
  }
`;
